/**
 * Gmail 아이콘 SVG
 *
 * 크기 조절: className으로 w-*, h-* 클래스 사용
 * @example
 * ```tsx
 * <GmailIcon className="w-8 h-8" />
 * <GmailIcon className="w-12 h-12" />
 * ```
 */
export function GmailIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      fill="none"
      className={className}
      aria-label="Gmail icon"
      role="img"
    >
      <title>Gmail</title>
      <g id="Gmail">
        <g id="Vector">
          <path
            d="M3.04548 28H7.81825V16.1546L1 10.9286V25.9096C1 27.0663 1.91706 28 3.04548 28Z"
            fill="#4285F4"
          />
          <path
            d="M24.1817 28H28.9545C30.0864 28 31 27.0628 31 25.9096V10.9286L24.1817 16.1546"
            fill="#34A853"
          />
          <path
            d="M24.1817 7.0963V16.1546L31 10.9286V8.14149C31 5.55639 28.1125 4.08268 26.0909 5.63304"
            fill="#FBBC04"
          />
          <path
            d="M7.81825 16.1546L7.81857 7.09631L16.0005 13.3674L24.1817 7.0963V16.1546L16.0005 22.4257"
            fill="#EA4335"
          />
          <path
            d="M1 8.14149V10.9286L7.81825 16.1546L7.81857 7.09631L5.90914 5.63304C3.88412 4.08268 1 5.55639 1 8.14149Z"
            fill="#C5221F"
          />
        </g>
      </g>
    </svg>
  );
}
